import { theme } from '../../../constants/environment'

export default {
	color: {
		brand: {
			primary: theme==="pluxee"?'#342870':'#E95949',
			primaryHover: theme==="pluxee"?'#423a6d':'#EE6D5B',
			primaryPressed: '#C14937',
			secondary: theme==="pluxee"?'#342870':'#E95949',
			tertiary: '#F4F4F0',
		},
		interactive: {
			primary: theme==="pluxee"?'#342870':'#566B76',
			primaryHover: theme==="pluxee"?'#423a6d':'#697D87',
			primaryPressed: '#465861',
			secondary: '#666666',
			tertiary: '#ffffff',
			tertiaryPressed: '#EBEDEF',
		},
		semantic: {
			info: '#62BDD0',
			positive: '#88BC76',
			neutral: '#997AB6',
			warning: '#FEB734',
			negative: '#EF7F43',
		},
		semanticBackground: {
			positive: '#F0F7EE',
		},
		background: {
			zebraTable: '#F9F9F7',
		},
		font: {
			primary: '#4D4D4D',
			secondary: '#666666',
			secondaryLight: '#E6E6E6',
			tertiary: theme==="pluxee"?'#342870':'#E95949',
			tertiaryGray: '#B3B3B3',
			interactive: theme==="pluxee"?'#342870':'#566B76',
			invert: '#ffffff',
			semantic: {
				info: '#62BDD0',
				success: '#88BC76',
				warning: '#EF7F43',
				danger: '#FEB734',
			},
		},
		border: {
			primary: '#E6E6E6',
			secondary: '#D5D7D9',
		},
	},
	spacing: {
		xs: '3px',
		sm: '6px',
		default: '12px',
		lg: '18px',
		xl: '24px',
		xxl: '36px',
		xxxl: '48px',
		xxxxl: '60px',
	},
	fontSize: {
		default: '12px',
		lg: '14px',
		xl: '16px',
		xxl: '18px',
		xxxl: '24px',
		xxxxl: '30px',
		xxxxxl: '36px',
	},
	font: {},
	borderRadius: {
		sm: '3px',
		lg: '6px',
	},
	animation: {
		curve: 'cubic-bezier(0.4, 0, 0.6, 0.8)',
	},
}
